import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number;
  name: string;
};

const [useCreatePortal, createPortal] = createAsyncAction(
  "portals/create",
  async ({ spaceId, name }: Args) => {
    const res = await API.call<{ portal: string }>({
      endpoint: "portals",
      method: "POST",
      data: {
        space_id: spaceId,
        name,
      },
    });
    return { ...res, result: res.result.portal };
  }
);

export default useCreatePortal;
export { createPortal };
